import React from "react";
import AcxChip from "components/UI/AcxChip";

/**
 * Marks a surface that is available but still being proven out. Uses AcxChip's `beta` color,
 * which was declared for exactly this and had no consumer until now.
 *
 * Takes the same optional `infoText` hover explanation as {@link AcxDeprecatedTag} so a caller
 * rendering whichever tag a surface declares never silently drops the message. Omit it and the
 * chip renders bare.
 */
export const AcxBetaTag = ({ infoText }: { infoText?: string }) => (
    <AcxChip
        size="small"
        color="beta"
        label="Beta"
        customTooltip={infoText}
        sx={{ marginBottom: 0 }}
    />
);

export default AcxBetaTag;
